import React from 'react'
import PropTypes from 'prop-types'
import { Route, withRouter, Switch } from 'react-router'

import Login from 'Auth/Zendesk/Login'
import Callback from 'Auth/Zendesk/Callback'

const AuthRouter = ({ match: { url } }) => (
  <Switch>
    <Route path={`${url}/login`} component={Login} />
    <Route path={`${url}/callback`} component={Callback} />
  </Switch>
)

AuthRouter.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  })
}

export default withRouter(AuthRouter)



// WEBPACK FOOTER //
// ./src/Auth/Zendesk/AuthRouter.js